import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { selectIsAuthenticated, selectRoles } from '../../store/authSlice';
import { AccessDenied } from './StateViews';
import AppLayout from './AppLayout';

/**
 * Gate that requires a valid session. Unauthenticated users go to /login with a
 * returnTo, matching the 401 handling in the axios interceptor. Authenticated
 * users get the Administration shell (AppLayout) wrapping the nested routes.
 */
export const RequireAuth = () => {
  const isAuthenticated = useSelector(selectIsAuthenticated);
  const location = useLocation();

  if (!isAuthenticated) {
    const returnTo = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/login?returnTo=${returnTo}`} replace />;
  }
  return (
    <AppLayout>
      <Outlet />
    </AppLayout>
  );
};

/**
 * Role gate. `roles` is the set allowed to see the nested routes. PlatformAdmin
 * is included explicitly on CIO/CFO route groups because it may enter the shared
 * modules. A logged-in user without an allowed role sees Access Denied (403),
 * never a silent empty page.
 */
export const RequireRole = ({ roles = [] }) => {
  const userRoles = useSelector(selectRoles);
  const allowed = roles.some((r) => userRoles.includes(r));
  return allowed ? <Outlet /> : <AccessDenied />;
};
